import { useRef, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import db from "../firebase-config";
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import HeaderMarinationTrack from '../components/header/HeaderMarinationTracking';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Time from '../assets/img/time.png';
import LensIcon from '@mui/icons-material/Lens';
import { useParams } from 'react-router-dom'


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: 'transparent',
    padding: theme.spacing(0.8),
    textAlign: 'center',
    border: '2px dashed #4A4A49',
    borderRadius: 10,
    height: '100%'

}));

const ItemInstock = styled(Paper)(({ theme }) => ({
    backgroundColor: '#0e2c27',
    padding: theme.spacing(0.4),
    textAlign: 'center',
    //border: '0.5px dashed #4A4A49',
    borderRadius: 5

}));

const ItemReady = styled(Paper)(({ theme }) => ({
    backgroundColor: '#302c2c',
    ...theme.typography.body2,
    padding: theme.spacing(0.2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));



const MarinationTrackingPage2 = () => {
    const { plant } = useParams();
    const marinateRef = useRef([]);
    const today = new Date();
    const hourago = new Date(today.getTime());

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 2);
    yesterday.setHours(0, 0, 0, 0);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [marinate, setMarinate] = useState([])
    const [marinate_page1, setMarinate_page1] = useState([])

    useEffect(() => {
        const subscriber = db
            .collection("prod_mes_ignition_preparation_zone_page1")
            .onSnapshot((querySnapshot) => {

                const getPostFromFirebase = [];

                querySnapshot.forEach((doc) => {
                    getPostFromFirebase.push({
                        ...doc.data(),
                        id: doc.id,
                    });
                });

                setMarinate_page1(getPostFromFirebase);
            });

        return () => subscriber();

    }, []);


    useEffect(() => {
        const subscriber = db
            .collection("prod_mes_ignition_preparation_zone_page2")
            .onSnapshot((querySnapshot) => {
                const newData = [];

                querySnapshot.forEach((doc) => {
                    newData.push({
                        ...doc.data(),
                        id: doc.id,
                    });
                });

                // ถ้าข้อมูลใหม่ไม่เหมือนกับข้อมูลที่เก็บไว้ใน marinateRef, อัปเดต state
                if (JSON.stringify(newData) !== JSON.stringify(marinateRef.current)) {
                    marinateRef.current = newData;
                    setMarinate(newData);
                }
            });

        return () => subscriber();
    }, []);

    const getValue = (data, line, tag) => {
        if (!data) return undefined;

        const lineName = plant === "4117" ? `LINE${line}` : `LINE${line - 6}`;
        const searchId = `${plant}.00000000000000.${lineName}${tag}`;

        return data.find((x) => x.id.includes(searchId));
    };

    const getReady = (line) => {
        if (!marinate) return [];

        const lineName = plant === "4117" ? `LINE${line}` : `LINE${line - 6}`;
        const searchId = `${plant}00000000000000${lineName}`;

        return marinate.filter((item) => item.id.includes(searchId));
    };

    const batch_line7 = getValue(marinate, 7, "NUMBER_OF_BATCH");
    const batch_line8 = getValue(marinate, 8, "NUMBER_OF_BATCH");
    const batch_line9 = getValue(marinate, 9, "NUMBER_OF_BATCH");
    const batch_line10 = getValue(marinate, 10, "NUMBER_OF_BATCH");
    const batch_line11 = getValue(marinate, 11, "NUMBER_OF_BATCH");
    const batch_line12 = getValue(marinate, 12, "NUMBER_OF_BATCH");

    const kg_instock_line7 = getValue(marinate, 7, "KG_IN_STOCK");
    const kg_instock_line8 = getValue(marinate, 8, "KG_IN_STOCK");
    const kg_instock_line9 = getValue(marinate, 9, "KG_IN_STOCK");
    const kg_instock_line10 = getValue(marinate, 10, "KG_IN_STOCK");
    const kg_instock_line11 = getValue(marinate, 11, "KG_IN_STOCK");
    const kg_instock_line12 = getValue(marinate, 12, "KG_IN_STOCK");

    const ready_line7 = getReady(7);
    const ready_line8 = getReady(8);
    const ready_line9 = getReady(9);
    const ready_line10 = getReady(10);
    const ready_line11 = getReady(11);
    const ready_line12 = getReady(12);

    const slice_ready_line7 = ready_line7 === undefined ? '' : ready_line7.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday; // ตรวจสอบว่าค่า FACTORY_DATE อยู่ในช่วงตั้งแต่เมื่อวานจนถึงตอนนี้
    });

    const slice_ready_line8 = ready_line8 === undefined ? '' : ready_line8.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    const slice_ready_line9 = ready_line9 === undefined ? '' : ready_line9.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    const slice_ready_line10 = ready_line10 === undefined ? '' : ready_line10.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    const slice_ready_line11 = ready_line11 === undefined ? '' : ready_line11.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });

    const slice_ready_line12 = ready_line12 === undefined ? '' : ready_line12.slice(0, 4).filter(item => {
        const factoryDate = new Date(item.FACTORY_DATE);
        return factoryDate >= yesterday;
    });



    const hour_line7 = getValue(marinate, 7, "HOUR");
    const hour_line8 = getValue(marinate, 8, "HOUR");
    const hour_line9 = getValue(marinate, 9, "HOUR");
    const hour_line10 = getValue(marinate, 10, "HOUR");
    const hour_line11 = getValue(marinate, 11, "HOUR");
    const hour_line12 = getValue(marinate, 12, "HOUR");

    const minute_line7 = getValue(marinate, 7, "MIN");
    const minute_line8 = getValue(marinate, 8, "MIN");
    const minute_line9 = getValue(marinate, 9, "MIN");
    const minute_line10 = getValue(marinate, 10, "MIN");
    const minute_line11 = getValue(marinate, 11, "MIN");
    const minute_line12 = getValue(marinate, 12, "MIN");


    const batch_line7_page1 = getValue(marinate_page1, 7, "CURRENT_BATCH");
    const batch_line8_page1 = getValue(marinate_page1, 8, "CURRENT_BATCH");
    const batch_line9_page1 = getValue(marinate_page1, 9, "CURRENT_BATCH");
    const batch_line10_page1 = getValue(marinate_page1, 10, "CURRENT_BATCH");
    const batch_line11_page1 = getValue(marinate_page1, 11, "CURRENT_BATCH");
    const batch_line12_page1 = getValue(marinate_page1, 12, "CURRENT_BATCH");


    return (
        <>
            <Helmet>
                <title>Marination Tracking Page1 | MES</title>
            </Helmet>
            <Grid container spacing={1} style={{ position: "relative", top: '-1.5vw' }}>
                <Grid item xs={12} sm={12}>
                    <HeaderMarinationTrack
                    />
                </Grid>

                <Grid container rowSpacing={0.5} columnSpacing={{ xs: 1, sm: 0.5, md: 0.5 }} style={{ backgroundColor: '#000000', paddingRight: 0, paddingTop: 5, paddingLeft: 10 }}>
                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line7 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 7' : 'Line 1'}
                                                </Typography>
                                            </Grid>
                                            {batch_line7?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line7 == undefined ? '-' : (batch_line7?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line7 == undefined ? '-' : Math.round(kg_instock_line7?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line7?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line7 == undefined ? '-' : hour_line7?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line7 == undefined ? '-' : minute_line7?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line7.length === 0
                                                    ? ''
                                                    : slice_ready_line7.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line7_page1?.CURRENT_BATCH === '' ? 0 : batch_line7_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>

                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line8 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 8' : 'Line 2'}
                                                </Typography>
                                            </Grid>
                                            {batch_line8?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line8 == undefined ? '-' : (batch_line8?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line8 == undefined ? '-' : Math.round(kg_instock_line8?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line8?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line8 == undefined ? '-' : hour_line8?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line8 == undefined ? '-' : minute_line8?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line8.length === 0
                                                    ? ''
                                                    : slice_ready_line8.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line8_page1?.CURRENT_BATCH === '' ? 0 : batch_line8_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>

                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line9 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 9' : 'Line 3'}
                                                </Typography>
                                            </Grid>
                                            {batch_line9?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line9 == undefined ? '-' : (batch_line9?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line9 == undefined ? '-' : Math.round(kg_instock_line9?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line9?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line9 == undefined ? '-' : hour_line9?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line9 == undefined ? '-' : minute_line9?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line9.length === 0
                                                    ? ''
                                                    : slice_ready_line9.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line9_page1?.CURRENT_BATCH === '' ? 0 : batch_line9_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>

                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line10 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 10' : 'Line 4'}
                                                </Typography>
                                            </Grid>
                                            {batch_line10?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line10 == undefined ? '-' : (batch_line10?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line10 == undefined ? '-' : Math.round(kg_instock_line10?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line10?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line10 == undefined ? '-' : hour_line10?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line10 == undefined ? '-' : minute_line10?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line10.length === 0
                                                    ? ''
                                                    : slice_ready_line10.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line10_page1?.CURRENT_BATCH === '' ? 0 : batch_line10_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>

                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line11 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 11' : 'Line 5'}
                                                </Typography>
                                            </Grid>
                                            {batch_line11?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line11 == undefined ? '-' : (batch_line11?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line11 == undefined ? '-' : Math.round(kg_instock_line11?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line11?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line11 == undefined ? '-' : hour_line11?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line11 == undefined ? '-' : minute_line11?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line11.length === 0
                                                    ? ''
                                                    : slice_ready_line11.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line11_page1?.CURRENT_BATCH === '' ? 0 : batch_line11_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>

                    <Grid item xs={6}>
                        <Item>
                            <Grid item xs={12} style={{ height: '23vh' }}>
                                {batch_line12 !== undefined ?
                                    <Grid container rowSpacing={1} columnSpacing={{ xs: 0, sm: 0, md: 0 }}>
                                        <Grid item xs={4.3}>
                                            <Grid item xs={12} textAlign="left">
                                                <Typography style={{ color: '#2e9281', fontSize: 40, fontWeight: 'bold', lineHeight: "4vh", position: "relative", top: "-0.2vw" }} >
                                                    &nbsp;{plant === '4117' ? 'Line 12' : 'Line 6'}
                                                </Typography>
                                            </Grid>
                                            {batch_line12?.NUMBER_OF_BATCH === 0 ? '' :
                                                <ItemInstock>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 46, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {batch_line12 == undefined ? '-' : (batch_line12?.NUMBER_OF_BATCH).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 30, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;Batch
                                                        </Typography>
                                                    </Box>

                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <Typography style={{ color: colors.neutral['white'], fontSize: 52, fontWeight: 'bold', lineHeight: "6vh" }} >
                                                            {kg_instock_line12 == undefined ? '-' : Math.round(kg_instock_line12?.KG_IN_STOCK).toLocaleString()}
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "6vh", position: "relative", top: "0.3vw" }} >
                                                            &nbsp;kg
                                                        </Typography>
                                                    </Box>
                                                </ItemInstock>
                                            }

                                            {batch_line12?.NUMBER_OF_BATCH === 0 ? '' :
                                                <Grid item xs={12} style={{ paddingTop: 10 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} textAlign="center" >
                                                        <img src={Time} height="28px" />
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            &nbsp;{hour_line12 == undefined ? '-' : hour_line12?.HOUR}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "3vh", position: "relative", top: "0.1vw" }} >
                                                            hr&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: '#74dcbc', fontSize: 44, lineHeight: "3vh", fontWeight: 'bold' }} >
                                                            {minute_line12 == undefined ? '-' : minute_line12?.MINUTE}&nbsp;
                                                        </Typography>
                                                        <Typography style={{ color: colors.neutral['grey'], fontSize: 32, lineHeight: "17px", position: "relative", top: "0.1vw" }} >
                                                            min
                                                        </Typography>
                                                    </Box>
                                                </Grid>}
                                        </Grid>

                                        <Grid item xs={0.2}>

                                        </Grid>

                                        <Grid item xs={7.5}>
                                            <Grid container rowSpacing={0.4} columnSpacing={{ xs: 0, sm: 0, md: 0 }} style={{ height: '78%' }}>
                                                {slice_ready_line12.length === 0
                                                    ? ''
                                                    : slice_ready_line12.map((item) => {
                                                        return <Grid item xs={6} style={{ paddingRight: 3 }}>
                                                            <ItemReady>
                                                                <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                    <Grid item xs={6} textAlign="left">
                                                                        <Typography style={{ color: hourago / 1000 >= item.READY_TIMESTAMP.seconds ? '#2e9281' : colors.neutral['grey'], fontSize: 38, lineHeight: "5vh", position: "relative", top: "0vw" }} >
                                                                            &nbsp;{item.BATCH}
                                                                        </Typography>
                                                                    </Grid>
                                                                    {(batch_line12_page1?.CURRENT_BATCH === '' ? 0 : batch_line12_page1?.CURRENT_BATCH) === item.BATCH ?
                                                                        <Grid item xs={6} style={{ position: "relative", top: "0.4vw" }} textAlign="right">
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>
                                                                            <LensIcon sx={{ color: "#8f9c32" }} style={{ fontSize: 18 }}></LensIcon>&nbsp;&nbsp;
                                                                        </Grid>
                                                                        : ''}

                                                                </Grid>
                                                                <Grid item xs={12} >
                                                                    <Grid container rowSpacing={0} columnSpacing={{ xs: 0.3, sm: 0, md: 0 }}>
                                                                        <Grid item xs={3} textAlign="right">
                                                                        </Grid>
                                                                        <Grid item xs={9} textAlign="right">
                                                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }} textAlign="right" >
                                                                                <Typography style={{ color: colors.neutral['white'], fontSize: 40, lineHeight: "5vh" }} >
                                                                                    {Math.round(item.KG).toLocaleString()}&nbsp;
                                                                                </Typography>
                                                                            </Box>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </ItemReady>
                                                        </Grid>
                                                    })}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    : ''}
                            </Grid>
                        </Item>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default MarinationTrackingPage2
